// const
const MAPBOX_TOKEN = 'pk.eyJ1IjoieWlob25nMDYxOCIsImEiOiJja2J3M28xbG4wYzl0MzJxZm0ya2Fua2p2In0.PNKfkeQwYuyGOTT_x9BJ4Q';
const MUNICIPALITY_CITIES_ARR = ['北京市', '上海市', '天津市', '重庆市', '香港特别行政区', '澳门特别行政区'];
const IS_CHINESE = true

export {
  MAPBOX_TOKEN, MUNICIPALITY_CITIES_ARR, IS_CHINESE
};
